import { RunContextApp } from 'framework/RCApp';
import { TemplatesResponse } from 'types/cx-editor';
import { createCxApiClient as createReal } from '../../apis/cxEditorAPI';
import { MOCK_TEMPLATES_RESPONSE } from 'lib/asset-templates';

// Minimal mock client - only for getTemplates
class CxMockTemplatesClient {
  async getTemplates(): Promise<TemplatesResponse> {
    return MOCK_TEMPLATES_RESPONSE;
  }
}

export function createCxApiClient(rc: RunContextApp, baseUrl: string) {
  const realClient = createReal(rc, baseUrl);
  const mockTemplatesClient = new CxMockTemplatesClient();
  
  // Use real API for all endpoints except getTemplates (which uses mock)
  return {
    getTemplates: mockTemplatesClient.getTemplates.bind(mockTemplatesClient),
    getTemplateMeta: realClient.getTemplateMeta.bind(realClient),
    getScenarios: realClient.getScenarios.bind(realClient),
    getInspector: realClient.getInspector.bind(realClient),
    getInspectorConfigs: realClient.getInspectorConfigs.bind(realClient),
    renderHTML: realClient.renderHTML.bind(realClient),
    renderDynamic: realClient.renderDynamic.bind(realClient),
    saveChanges: realClient.saveChanges.bind(realClient),
    save: realClient.save.bind(realClient),
    toggleOverride: realClient.toggleOverride.bind(realClient),
    signoff: realClient.signoff.bind(realClient),
    getPalette: realClient.getPalette.bind(realClient),
    getDataScenarios: realClient.getDataScenarios.bind(realClient),
    saveStrings: realClient.saveStrings.bind(realClient),
  } as any;
}





